class APIJSONMatchError extends Error {
	constructor(msg?: string) {
		super(msg);
	}
}

export { APIJSONMatchError };
